import api from './api';

// ==================== Types ====================

export interface OrderFile {
  id: number;
  order_id: number;
  file_type: 'bol' | 'do' | 'paperwork' | 'other';
  file_url: string;
  file_name: string | null;
  file_size: number | null;
  mime_type: string | null;
  uploaded_by: number | null;
  uploaded_by_name: string | null;
  notes: string | null;
  created_at: string;
}

export interface TaskPhotoGroup {
  taskId: string;
  taskType: string;
  taskStatus: string;
  photos: TaskPhoto[];
  images: TaskImage[];
}

export interface TaskPhoto {
  id: number;
  task_id: number;
  photo_url: string;
  photo_type: string;
  uploaded_at: string;
  task_display_id: string;
  task_type: string;
}

export interface TaskImage {
  id: number;
  task_id: number;
  file_type: string;
  file_url: string;
  file_name: string | null;
  file_size: number | null;
  mime_type: string | null;
  category: string;
  uploaded_at: string;
  task_display_id: string;
  task_type: string;
}

// ==================== API ====================

export const orderFileApi = {
  /**
   * Upload file to order (multipart form)
   * POST /api/orders/:orderId/files/upload
   */
  async uploadFile(orderId: number, file: File, fileType: string, notes?: string): Promise<OrderFile> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_type', fileType);
    if (notes) formData.append('notes', notes);
    const response = await api.post(`/orders/${orderId}/files/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /**
   * Get all files for an order
   * GET /api/orders/:orderId/files
   */
  async getFiles(orderId: number, fileType?: string): Promise<OrderFile[]> {
    const params = fileType ? `?file_type=${fileType}` : '';
    const response = await api.get(`/orders/${orderId}/files${params}`);
    return response.data;
  },

  /**
   * Delete a file from order
   * DELETE /api/orders/:orderId/files/:fileId
   */
  async deleteFile(orderId: number, fileId: number): Promise<OrderFile> {
    const response = await api.delete(`/orders/${orderId}/files/${fileId}`);
    return response.data;
  },

  /**
   * Get all driver photos from tasks under this order (read-only)
   * GET /api/orders/:orderId/task-photos
   */
  async getTaskPhotos(orderId: number): Promise<TaskPhotoGroup[]> {
    const response = await api.get(`/orders/${orderId}/task-photos`);
    return response.data;
  },
};

export default orderFileApi;
